import LangEnum from '../../../../../../lang/LangEnum';
import snackbarStore from '../../../../../../stores/Snackbar.store';
import { TranslateType } from '../../../../../translation/translationContext.types';
import { WsErrorsStrategy } from '../types/wsErrorsStrategy.type';

export class TooManyRequestsStrategy implements WsErrorsStrategy {
  constructor(private readonly translate: TranslateType) {}

  handle() {
    snackbarStore.handleMessage({
      type: 'warning',
      message: this.translate(LangEnum.TOO_MANY_REQUESTS_TO_CHAT),
    });
  }
}
